import React from "react";
// import ZenDonut from "../Graph/ZenDonut";
import Angela from "../DataCard/Angela";

import liracrypt from "../../../../../src/components/Liracrypt/liracrypt";
import SessionError from "../../../../../src/components/ApiErrorComp/SessionError";
import ApiErrorComp from "../../../../../src/components/ApiErrorComp/ApiErrorComp";

class ZenContainerAngela extends React.Component {
  state = {
    ZenDonut:null,
    loading: true,
    loginError: false,
    dataLoading: false,
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  componentDidMount() {
    // this.props.setPageHeader("Dashboard");
    this._isMounted = true;
    this.fetchTrendData()
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  fetchTrendData = ( ) => {
    liracrypt
      // .get("/textapi", {
      //   apiName: "ContainerChartAngela",
      // })
      .get("/textapi", this.props.urlData || {})
      .then(({ data }) => {
        const resp = { ...data };
        let respData = {};
        respData["data"] = resp["data"];
        respData["config"] = resp["config"];
        respData["mainData"] = { ...resp };
        this._isMounted &&
          this.setState(
            {
              ...this.state,
              ...respData,
              loading: false,
              dataLoading: false,
            },
            () => {
              // console.log(this.state.dailyTrend);
            }
          );
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  render() {
    if (this.state.mainData) {
      // console.log("________________________________HELLO________________")
      // console.log(this.state.mainData)
      return (
        <div
              style={{
                width: "99%",
              }}
            >
              <Angela
                divId={this.props.divId || "Angela1"}
                data={this.state.mainData.data}
                config={this.state.mainData.config}
              />
            </div>
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}
export default ZenContainerAngela;